import {
  CustomDetector,
  DetectorOptions
} from 'i18next-browser-languagedetector';
import { AuthFlowBuilder } from './AuthFlow';
import { SimpleQueryParser } from './SimpleQueryParser';

export interface AuthDetectorOptions extends DetectorOptions {
  auth0LookupQueryString: string;

  auth0LanguageProperty: string;
}

export class AuthLanguageDetector implements CustomDetector {
  name = 'auth';

  public lookup(options: AuthDetectorOptions): string | undefined {
    const searchOptions: AuthDetectorOptions = {
      ...this.getDefaults(),
      ...options
    };

    const authParams = new AuthFlowBuilder()
      .withQueryParam(searchOptions.auth0LookupQueryString)
      .withCultureFieldName(searchOptions.auth0LanguageProperty)
      .build();
    let { culture } = authParams;
    if (!culture) {
      const parser = new SimpleQueryParser();
      const errorDescription = (
        parser.getQueryParam('error_description') || ''
      ).split('~');
      if (errorDescription) {
        try {
          culture = JSON.parse(errorDescription[1]).culture;
        } catch (error) {
          culture = undefined;
        }
      }
    }
    return culture;
  }

  private getDefaults = (): AuthDetectorOptions => {
    return {
      auth0LookupQueryString: 'wauth',
      auth0LanguageProperty: 'culture'
    };
  };
}
